export default __webpack_public_path__ + "static/media/homepage-header-background.0f5ffd71.svg";